import type { ApiItemResponse, ApiListResponse, Category, EventDateRange, ItemDetail, ItemSummary, LanguageCode, SiteSettings, Tag } from '@/types';

async function apiGet<T>(path: string, params: Record<string, string | number | undefined> = {}): Promise<T> {
  const url = new URL(path, window.location.origin);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      url.searchParams.set(key, String(value));
    }
  });

  const res = await fetch(url.toString());
  if (!res.ok) {
    throw new Error(`API hiba (${res.status}): ${url.pathname}`);
  }
  return res.json() as Promise<T>;
}

export async function fetchCategories(lang: LanguageCode): Promise<Category[]> {
  const json = await apiGet<ApiListResponse<Category>>('/api/categories.php', { lang });
  return json.data;
}

export async function fetchTags(lang: LanguageCode): Promise<Tag[]> {
  const json = await apiGet<ApiListResponse<Tag>>('/api/tags.php', { lang });
  return json.data;
}

export interface ItemsFilter {
  categoryId?: number;
  tagId?: number;
  type?: string;
  q?: string;
  /** ISO 'YYYY-MM-DD' — csak együtt van értelme a kettőnek */
  dateFrom?: string;
  dateTo?: string;
}

export async function fetchItems(lang: LanguageCode, filter: ItemsFilter = {}): Promise<ItemSummary[]> {
  const json = await apiGet<ApiListResponse<ItemSummary>>('/api/items.php', {
    lang,
    category_id: filter.categoryId,
    tag_id: filter.tagId,
    type: filter.type,
    q: filter.q,
    date_from: filter.dateFrom,
    date_to: filter.dateTo,
  });
  return json.data;
}

export async function fetchItemDetail(lang: LanguageCode, id: number): Promise<ItemDetail> {
  const json = await apiGet<ApiItemResponse>('/api/items.php', { lang, id });
  return json.data;
}

export async function fetchEventDateRange(): Promise<EventDateRange> {
  const json = await apiGet<{ data: EventDateRange }>('/api/event_date_range.php', {});
  return json.data;
}

export async function fetchSiteSettings(): Promise<SiteSettings> {
  const json = await apiGet<{ data: SiteSettings }>('/api/settings.php', {});
  return json.data;
}
